export enum CardEnum {
    ResourceBack = 0,
    Lumber = 1,
    Brick = 2,
    Wool = 3,
    Grain = 4,
    Ore = 5,
    Cloth = 6,
    Coin = 7,
    Paper = 8,
    AnyResource = 9,
    DevelopmentBack = 10,
    Knight = 11,
    VictoryPoint = 12,
    Monopoly = 13,
    RoadBuilding = 14,
    YearOfPlenty = 15,
    CommodityBack = 16,
    ProgressCardTradeBack = 17,
    ProgressCardTradeCommercialHarbor = 18,
    ProgressCardTradeMasterMerchant = 19,
    ProgressCardTradeMerchant = 20,
    ProgressCardTradeMerchantFleet = 21,
    ProgressCardTradeResourceMonopoly = 22,
    ProgressCardTradeCommodityMonopoly = 23,
    ProgressCardPoliticsBack = 24,
    ProgressCardPoliticsBishop = 25,
    ProgressCardPoliticsConstitution = 26,
    ProgressCardPoliticsDeserter = 27,
    ProgressCardPoliticsDiplomat = 28,
    ProgressCardPoliticsIntrigue = 29,
    ProgressCardPoliticsSaboteur = 30,
    ProgressCardPoliticsSpy = 31,
    ProgressCardPoliticsWarlord = 32,
    ProgressCardPoliticsWedding = 33,
    ProgressCardScienceBack = 34,
    ProgressCardScienceAlchemist = 35,
    ProgressCardScienceCrane = 36,
    ProgressCardScienceEngineer = 37,
    ProgressCardScienceInventor = 38,
    ProgressCardScienceIrrigation = 39,
    ProgressCardScienceMedicine = 40,
    ProgressCardScienceMining = 41,
    ProgressCardSciencePrinter = 42,
    ProgressCardScienceRoadBuilding = 43,
    ProgressCardScienceSmith = 44,
    ProgressCardBack = 45,
}

export enum CardTypeEnum {
    Resource = 0,
    Commodity = 1,
    AnyResource = 2,
    Development = 3,
    ProgressTrade = 4,
    ProgressPolitics = 5,
    ProgressScience = 6,
}

export enum CardDistributionType {
    StartingResources = 0,
    ResourceTile = 1,
    GoldTile = 2,
    Aqueduct = 3,
    BarbarianProgressCard = 4,
}

// Used when order matters.
// Example: Development and Progress Cards have a specific drawing order. So order does matter.
// Memory usage is higher and should only be used when order matters
export interface CardStateOrdered {
    cards: CardEnum[]
}

// Used when order does not matter
// Example: Bank resource cards. Only the total of each card matters = , order does not matter.
// Memory usage is lower and is the preferred choice unless order matters
export type CardStateUnordered = {
    [key in CardEnum]?: number
}
